export type Testimonial = {
  id: string;
  name: string;
  credential: string;
  photo: string;
  quote: string;
};

export const testimonialsPrimary: Testimonial[] = [
  {
    id: 'p1',
    name: 'Maya Ellison',
    credential: 'RYT-500 · Portland, OR',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8a9cbb39-07e8-404c-abaa-05793c6bff26.jpg',
    quote:
      '"A new student told me she had a lumbar disc herniation while she was unrolling her mat. I said the line from the Quick Card almost word for word — \'we\'ll keep your spine long instead of rounding, and I\'ll give you a block option every time we fold.\' She stayed for the whole class and booked the next one."',
  },
  {
    id: 'p2',
    name: 'Priya Raghavan',
    credential: 'Hot vinyasa studio · Austin, TX',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d7233c8b-2281-40b7-9367-b01b3c211b84.jpg',
    quote:
      '"Someone said \'SI joint\' two minutes before a hot class. I opened the PDF on my phone and had the page in about forty seconds, with her standing right there. I\'ve never been able to look something up that fast without looking lost."',
  },
  {
    id: 'p3',
    name: 'Claire Baptiste',
    credential: '11 years teaching · Montréal',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a9417b79-2a64-402c-89b6-a7e425f2fe3d.jpg',
    quote:
      '"I referred a student out for numbness down her arm, using the refer-out script so it didn\'t sound like I was turning her away. She came back three weeks later with a diagnosis and a note from her physio. My studio now puts me on the Saturday all-levels class nobody else wanted."',
  },
];

export const testimonialsSecondary: Testimonial[] = [
  {
    id: 's1',
    name: 'Nadia Whitlock',
    credential: 'RYT-200 · Leeds, UK',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a4373452-c96a-45a0-9c28-1445faef2a9d.jpg',
    quote:
      '"The Script Library in Volume 1 is the part I actually use. I used the whole-room option script for the first time in week two and nobody had to single themselves out — the whole class just took the version they needed."',
  },
  {
    id: 's2',
    name: 'Jo Ferreira',
    credential: 'RYT-500 · Lisbon',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a515ad9d-bca8-4aab-90e4-0252d01e9973.jpg',
    quote:
      '"The Inversion Decision Matrix changed how I sequence. I hadn\'t registered that down dog and bridge count as inversions for a student with glaucoma — now I know exactly which shapes to swap and what to say while I do it."',
  },
  {
    id: 's3',
    name: 'Renée Oyelaran',
    credential: '8 years teaching · Toronto',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/46d35dc6-6563-42bc-a808-654a6dac9be2.jpg',
    quote:
      '"I went into a studio interview and got the injury scenario question almost verbatim from the Scenario Builder. I answered with the Acknowledge–Clarify–Offer–Stay Clear formula and they told me it was the clearest answer they\'d had. Volume 6 is why I stopped apologising for my limits."',
  },
];
